<ng-container *transloco="let t" class="container">
  <div class="modal-body">
    <div class="d-flex align-items-center pb-4">
      <img src="assets/img/svg/T.svg" alt="Tracey logo">
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{ title ? t(title) : "" }}
        </div>
      </div>
      <div class="pe-20 d-flex">
        <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')"></button>
      </div>
    </div>
    <div class="body-wrapper">
      <table class="w-100">
        <thead class="admin-modal-table-underline">
        <tr>
          <th class="py-6">{{ t('organiser.event.details.control.point.name') }}</th>
          <th class="py-6 point-type-width">{{ t('organiser.event.details.control.point.type') }}</th>
          <th class="py-6 text-center">Copy</th>
          <th class="py-6 text-center delete-width">Delete</th>
        </tr>
        </thead>
        <tbody>
          @for (waypoint of listOfWaypoints; track waypoint.id; ) {
            <tr class="admin-modal-table-underline">
              <td class="center-align">
                <app-language-output [hrLabel]="waypoint.pointNameHr" [enLabel]="waypoint.pointNameEn"
                                     [itLabel]="waypoint.pointNameIt" [siLabel]="waypoint.pointNameSlo" [srLabel]="waypoint.pointNameSr" [bsLabel]="waypoint.pointNameBs"
                                     [defaultLanguage]="raceWaypointsComponent!.event!.defaultLanguage"
                                     [languages]="raceWaypointsComponent!.languages"/>
              </td>
              <td class="py-6">
                <div class="status-badge mb-4px  text-center"
                     [ngClass]="{'blue': waypoint.waypointTypeId === WaypointType.START_WAYPOINT , 'accepted':
                              waypoint.waypointTypeId === WaypointType.CONTROL_WAYPOINT, 'denied': waypoint.waypointTypeId === WaypointType.FINISH_WAYPOINT ,
                               'on-hold': waypoint.waypointTypeId === WaypointType.OTHER_WAYPOINT}">
                              <span class="fw-bold">
                                {{
                                  t("organiser.event.details.control.point.waypointType."
                                    + waypoint.waypointTypeId) | uppercase
                                }}
                              </span>
                </div>
              </td>
              <td class="py-6 text-center cursor-pointer">
                <i class="fa-regular fa-copy" (click)="onCopyWaypoint(waypoint)"
                   ngbTooltip="{{ t('organiser.event.details.control.point.copy') }}"
                   placement="left"></i>
              </td>
              <td class="py-6 text-center cursor-pointer">
                <i class="fas fa-trash-alt color-primary" (click)="onDeleteWaypoint(waypoint)"></i>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="d-flex justify-content-center align-items-center pb-40-48">
    <div class="d-flex">
      <div class="pe-3">
        <app-rounded-button [label]="dismissButtonTitle ?? t('app.common.cancel')"
                            [btnClass]="'btn-grey text-uppercase'" (onClick)="onDismissClick()"/>
      </div>
    </div>
  </div>
</ng-container>
